import { Icon } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

import Popup from "../../../../ui/components/Popup/Popup";

export default function TodoPinnedBy({ todo }) {
	const { t } = useTranslation();

	return (
		<Popup
			trigger={
				<Icon name="pin" color="orange" style={{ fontSize: 16, position: "absolute", right: 7, bottom: 15 }} />
			}
			content={t("pinnedBy", "Pinned by {{user}}", { user: todo.pinned.user.name })}
		/>
	);
}
